/**
 * Site-wide SVG filter for keying out white backgrounds on product photos
 * so the fresheners appear to hang in mid-air.
 *
 * How it works:
 *  1. feColorMatrix on the alpha channel: new_alpha = 3A - R - G - B, which
 *     makes pure white pixels (R+G+B ≈ 3, A = 1) collapse to alpha 0 while
 *     any coloured pixel keeps its full alpha.
 *  2. feMorphology dilates the resulting alpha by 1px, feFlood paints it
 *     pink, feComposite masks the flood by the dilated alpha → the pink
 *     traces the die-cut edge. Original source is composited on top.
 *
 * Rendered once at the root so any element can use `filter: url(#bb-diecut-key)`.
 */
export default function DieCutFilter() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden focusable="false">
      <defs>
        <filter id="bb-diecut-key" x="-5%" y="-5%" width="110%" height="110%" colorInterpolationFilters="sRGB">
          {/* Linear key: new_alpha = 8A - 2.7(R+G+B).
              Pure white → -0.1 (transparent). JPEG-compressed off-white
              (~R=G=B=0.94) → 0.38 (also gets zeroed by the discrete step).
              Any pixel with colour variance (skin peach, red bikini, pink
              hair, blonde) stays fully opaque because the sum drops below 3. */}
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="1 0 0 0 0
                    0 1 0 0 0
                    0 0 1 0 0
                    -2.7 -2.7 -2.7 8 0"
            result="keyed"
          />
          {/* Hard alpha cliff at ~0.5 — anything above stays fully opaque so
              the model has no half-alpha halo; anything below snaps to 0 so
              off-white studio backgrounds disappear cleanly. */}
          <feComponentTransfer in="keyed">
            <feFuncA type="discrete" tableValues="0 0 0 0 1 1 1 1" />
          </feComponentTransfer>
        </filter>
      </defs>
    </svg>
  );
}
